import React from 'react'
import { useSelector } from 'react-redux'
import AdForm from 'pages/ArcAd/AdForm'
import useAction from 'utils/useAction'
import * as actions from 'actions/views/arcAds'
import { selectors as arcAdsSelectors } from 'domains/arcAds'

const ArcAdModal = ({ closeModal, ...data }) => {
  const fetchAds = useAction(actions.fetchArcAds)
  const page = useSelector(arcAdsSelectors.getPage)
  const searchString = useSelector(arcAdsSelectors.getSearchString)

  const handleSuccess = () => {
    // Refresh the data with current page and search
    fetchAds({
      page,
      search: searchString,
      filters: {},
      sorter: {sort: 'created_at'}
    })
    closeModal()
  }

  const handleCancel = () => {
    closeModal()
  }

  return (
    <AdForm
      adId={data?.id || null}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  )
}

export default ArcAdModal